import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HOME_SEO, SEO_PAGES, NOINDEX_PREFIXES, SITE_URL } from "@/lib/seo";

const setMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

const FLEET_SEO = {
  title: "Fleet Customer Login | Sagittarius Motor Works",
  description: "Fleet and business customers: sign in to see your vehicles and service history with Sagittarius Motor Works, Mount Maunganui.",
};

export const RouteSeo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname.replace(/\/+$/, "") || "/";
    const onStagingHost = window.location.hostname === "motor-works-hub.emergent.host";
    const privateRoute = NOINDEX_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));
    const page = path === "/" ? HOME_SEO : path === "/fleet" ? FLEET_SEO : SEO_PAGES[path];
    const noindex = onStagingHost || privateRoute || !page;
    const title = page?.title || (privateRoute ? "Sagittarius Motor Works" : "Page not found | Sagittarius Motor Works");
    const description = page?.description || HOME_SEO.description;

    document.title = title;
    setMeta('meta[name="description"]', { name: "description", content: description });
    setMeta('meta[name="robots"]', { name: "robots", content: noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1" });
    setMeta('meta[property="og:title"]', { property: "og:title", content: title });
    setMeta('meta[property="og:description"]', { property: "og:description", content: description });
    setMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    setMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    if (page) {
      const url = `${SITE_URL}${path === "/" ? "/" : path}`;
      setMeta('link[rel="canonical"]', { rel: "canonical", href: url });
      setMeta('meta[property="og:url"]', { property: "og:url", content: url });
    }
    if (path !== "/") window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
